const Alert = ({ message }) => {
    return (
        <div className="flex border border-solid border-sf-alert rounded bg-white">
            <div className="text-sf-alert pr-2 py-3 pl-3">
                <i className={`fa fa-exclamation-triangle text-2.5xl`}></i>
            </div>
            <div className="flex items-center">{message}</div>
        </div>
    );
};

export default Alert;
